export default __webpack_public_path__ + "static/media/orange_eye.de015c3b.svg";